import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgLineDown(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.096 6.706a.5.5 0 0 1 .698-.11l5.192 3.775 2.202-1.761.306-.245.31.239 6.5 5a.5.5 0 0 1-.609.792l-6.189-4.76-2.194 1.755-.298.238-.308-.225-5.5-4a.5.5 0 0 1-.11-.698ZM19.5 11a.5.5 0 0 1 .5.5V16h-4.5a.5.5 0 1 1 0-1H19v-3.5a.5.5 0 0 1 .5-.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineDown);

var LineDownOutline = forwardRef((props, ref) => jsx(ForwardRef, Object.assign({
  ref: ref
}, props)));

export { LineDownOutline as default };
